
import React, { useEffect } from "react";
import * as echarts from "echarts";
import { Menu, Dropdown, Button, Space, Row, Col } from 'antd';
import { DownOutlined } from '@ant-design/icons';

export interface MenuInfo {
    key: string;
    keyPath: string[];
    item: React.ReactInstance;
    domEvent: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>;
}

type EChartsOption = echarts.EChartsOption;

let myChart: echarts.ECharts | null = null;

export const BarChart = (params: {
    id: string;
    subtitle: string;
    dimensions: string [];
    sources: any[];
    hideExport?: boolean,
    exportPost?: any,
    exportFileName?: string
}) => {
    const { sources, id, subtitle, dimensions, hideExport, exportPost, exportFileName } = params;

    const onMenuClickHandle = (value: MenuInfo) => {
        switch (value.key) {
            case '1':
                const url = myChart?.getDataURL({
                    pixelRatio: 2,
                    backgroundColor: '#fff'
                });

                if (url) {
                    fetch(url).then(async res => await res.blob()).then((blob) => {
                        // 创建隐藏的可下载链接
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = URL.createObjectURL(blob);
                        // 保存下来的文件名
                        a.download = 'image.png';
                        document.body.appendChild(a);
                        a.click();
                        // 移除元素
                        document.body.removeChild(a);
                    })
                }
                break;

            case '2':
                exportPost().then((res: any) => {
                    let blob = new Blob([res], {
                        type: 'application/octet-stream'
                    }); // 转化为blob对象
                    let filename = `${exportFileName}.xlsx`;

                    const blobURL = window.URL.createObjectURL(blob); // 将blob对象转为一个URL
                    const tempLink = document.createElement('a'); // 创建一个a标签
                    tempLink.style.display = 'none';
                    tempLink.href = blobURL;
                    tempLink.setAttribute('download', filename); // 给a标签添加下载属性
                    if (typeof tempLink.download === 'undefined') {
                        tempLink.setAttribute('target', '_blank');
                    }
                    document.body.appendChild(tempLink); // 将a标签添加到body当中
                    tempLink.click(); // 启动下载
                    document.body.removeChild(tempLink); // 下载完毕删除a标签
                    window.URL.revokeObjectURL(blobURL);
                })
                break;
        }
    }
    const menu = (
        <Menu
            onClick={(value: MenuInfo) => { onMenuClickHandle(value) }}
            items={[
                {
                    label: '导出图片格式',
                    key: '1'
                },
                {
                    label: '导出excel格式',
                    key: '2'
                }
            ]}
        />
    );

    useEffect(() => {
        const chartDom = document.querySelector(
            `#${id}`
        ) as HTMLElement;
        myChart = echarts.init(chartDom);
        let option: EChartsOption;

        let dimen;
        let serie;
        let color;
        if (dimensions.length === 2) {
            dimen = ["product", dimensions[0], dimensions[1]];
            serie = [{ type: "bar" }, { type: "bar" }];
            color = ["#3c90f7", "#55bfc0"];
        } else {
            dimen = ["product", dimensions[0]];
            serie = [{ type: "bar" }];
            color = ["#3c90f7"];
        }

        option = {
            title: {
                subtext: subtitle,
            },
            legend: {
                top: "bottom",
                itemWidth: 10,
                itemHeight: 10
            },
            tooltip: { trigger: "axis" },
            dataset: {
                dimensions: dimen,
                source: sources,
            },
            xAxis: { type: "category" },
            yAxis: {},
            series: serie as any,
            color: color,
        };

        option && myChart.setOption(option);
    }, [sources]);

    return (
        <div className="datamanager-histogram">
            {
                !hideExport && (
                    <Row className="datamanager-histogram-options">
                        <Col span={21}></Col>
                        <Col span={3}>
                            <Dropdown overlay={menu}>
                                <Button type="primary">
                                    <Space>
                                        导出
                                        <DownOutlined />
                                    </Space>
                                </Button>
                            </Dropdown>
                        </Col>
                    </Row>
                )
            }

            <div id={id} className="datamanager-histogram-container"></div>
        </div>
    );
};
